export default "__VITE_ASSET__913e335d__"